export const renderIcon = ({ name, folder }) => {
    return <img src={`/${folder}/${name}.svg`} alt="" />;
};
